module.exports = __webpack_public_path__ + "img/ornament.e63c0437.svg";